import { useQuery } from '@tanstack/react-query';
import apiClient from './api-client';
const SCOPE = 'contract-iframe';
const DETAIL = 'detail';
const keysFactory = {
    all: (financingProgram) => [{ scope: SCOPE, financingProgram }],
    allDetails: (financingProgram) => [{ scope: SCOPE, entity: DETAIL, financingProgram }],
    detail: (id, financingProgram) => [{ scope: SCOPE, entity: DETAIL, id, financingProgram }],
};
const createGetContractIframeUrl = (financingProgram) => {
    return async ({ queryKey: [{ id }] }) => {
        const response = await apiClient.get(`/${financingProgram}/creditApplication/${encodeURIComponent(id)}/contract/iframeLink`);
        return response.data;
    };
};
export function useGetContractIframeUrl(creditApplicationId, financingProgram, enabled) {
    const getContractIframeUrl = createGetContractIframeUrl(financingProgram);
    const { isFetching, failureCount, data } = useQuery({
        queryKey: keysFactory.detail(creditApplicationId, financingProgram),
        queryFn: getContractIframeUrl,
        enabled: enabled,
        retry: 6, // Retry up to 6 times on failure
        retryDelay: 20000, // Refetch every 20 seconds 
        staleTime: 0, // disable caching because it blocks first fetch sometimes
    });
    return [data, isFetching, failureCount];
}
export function useGetContractIframeUrlQuery(creditApplicationId, financingProgram, enabled) {
    const getContractIframeUrl = createGetContractIframeUrl(financingProgram);
    return useQuery({
        queryKey: keysFactory.detail(creditApplicationId, financingProgram),
        queryFn: getContractIframeUrl,
        enabled,
        retry: 6, // Retry up to 6 times on failure
        retryDelay: 20000, // Refetch every 20 seconds
        staleTime: 0, // disable caching because it blocks first fetch sometimes
    });
}
